module.exports = __webpack_public_path__ + "static/media/footer-wave-desktop.28d6b877.png";